import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Timeline, TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ThorAnimatedWinlineController} from "../animatedwinlines/ThorAnimatedWinlineController";
import {ThorGameConfig} from "../../ThorGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";

/**
 * Created by Jerker Nord on 2019-01-08.
 */

export class ThorIndividualWPController extends BetLineWinIndividualWPController {

    constructor(config:IIndividualWinPresentationConfig, name:string = "BetLineIndividualWin", tweakEnabled?:boolean) {
        super(config, name, tweakEnabled);
    }

    protected startWinPresentation():void {
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        super.startWinPresentation();
    }

    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        const timeline:Timeline = new TimelineLite();
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(ThorAnimatedWinlineController.PLAY_ANIMATED_WINLINE, (betLineWinData.betLineIndex)));
        });

        for(let i:number = 0; i < betLineWinData.nrOfSymbols; i++) {
            const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
            if(symbol) {
                this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i]), symbol, i, betLineWinData.betLine[i]);
                this._winSymbols.push(symbol);
            }
        }

        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbol.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.win,
                setStack : true,
                fadeInDuration : 0.6
            })
        ], startTime);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
        EventHandler.dispatchEvent(new GameEvent(ThorAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE));
    }
}